import React, { useState } from 'react'  
import { Button } from '@blueprintjs/core'
import { __ } from '@libs/utilities'  
import { ICritery, IFestival, IProject, IRating } from '@/modules/pe-fest-module/data/interfaces'
import CriteryCommentaryDialog from '../projectData/CriteryCommentaryDialog'
import { IFestDataStor, IFestProjectsProps, useFestDataStore, useFestProjects } from '@/modules/pe-fest-module/data/store'
import { IState, IUser, useMainStore } from '@/settings/zustand'
import { actions } from '@/modules/pe-fest-module/data/actions'
import { UDATE_PROJECT_RATING_ACTION } from '@/modules/pe-fest-module/data/actionTypes'
import updateLocalRating from '@/modules/pe-fest-module/data/utils/updateLocalRating'
import Shortcode from 'src/libs/useful/shortcode'

interface ICriteryDescriptionDisplayProps {
    isExpert: boolean
    critery: ICritery
    description: string
    onOpen: () => void
}

const CriteryDescriptionDisplay = (props: ICriteryDescriptionDisplayProps) :JSX.Element | null =>  {
    const project: IProject = useFestProjects((state: IFestProjectsProps) => state.currentProject) 
    const user:IUser = useMainStore((state:IState) => state.user)
    const festival:IFestival = useFestDataStore((state:IFestDataStor) => state.festival)
    const rating: IRating | null = project.ratings?.filter(( rating:IRating ) => {
        return rating.criteryId === props.critery.id && rating.expertId === user.id 
    })[0] 
    
    const maxRating: number = festival.isIndependentGradeCritery ? props.critery.max_rating : festival.maxRating || 5
    const [isOpen, setIsOpen] = useState( false) 
    // if( !props.isExpert ) return null

    const onSend = (description: string) => {
        const _newRating = { 
            expertId: rating.expertId,
            display_name: rating.display_name,
            criteryId: props.critery.id,
            memberId: project.id,
            description,
            rating: rating?.rating || 0,
            correct_rating:  rating?.correct_rating || 0,
            correct_description: rating?.correct_description || "", 
            correct_user_id: rating?.correct_user_id || user.id, 
            correct_display_name: rating?.correct_display_name || user.display_name, 
        }
        const data: any = {
            id: "-1",
            item : _newRating,
            landId: festival.id
        }
        updateLocalRating( {...rating, ..._newRating} as IRating )
        actions( UDATE_PROJECT_RATING_ACTION, data )
    }
    // console.log( rating )
    return !!rating?.rating
        ?
        <div className="text-secondary font-weight-light pe-surface-none">
            <span className=" descr-label mr-3">
                {__("Your description:")}
            </span>
            <Shortcode className="font-italic critery-descr" content={ props.description } /> 
            <Button
                variant="minimal"
                className=" pe-surface"
                icon="edit"
                title={ __( "Edit" ) }
                onClick={() => setIsOpen( !isOpen )}
            >            
            </Button>     
            <CriteryCommentaryDialog
                description={ rating?.description || "" }
                isOpen={ isOpen }
                onOpen={ () => setIsOpen( false) }
                lockWithoutComment={ maxRating === rating?.rating || false }
                onSend={onSend}
                sendLabel={"send label"}
                isHideChangeDescr={false}
            />        
        </div>
        :
        <></>
} 

export default CriteryDescriptionDisplay